<pbc-sorter [config]="TourStatiSorterConfig" [sorter]="tourStati.sorter$ | async" (sorterChange)="tourStati.sorter$.next($event)"></pbc-sorter>
